import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { CORE_API_SUFFIX, dataFetch } from '../../axios/customAxios';

export interface OAuthConsentClient {
  id: string;
  name: string;
  contacts?: string[];
  redirect_uri_host: string;
  registration_type: string;
}

export interface OAuthConsentScope {
  id: string;
  description: string;
}

export interface OAuthConsentOrganization {
  id: number;
  name: string;
}

export interface OAuthConsentView {
  client: OAuthConsentClient;
  organization: OAuthConsentOrganization;
  scopes: OAuthConsentScope[];
  state: string;
  existing_grant: boolean;
}

export const useOAuthConsent = (state: string | null) => useQuery<AxiosResponse<OAuthConsentView>>(
  ['oauthConsent', state],
  () => dataFetch.get<OAuthConsentView>(
    `${CORE_API_SUFFIX}oauth/consent?state=${encodeURIComponent(state ?? '')}`,
  ),
  {
    enabled: !!state,
    retry: false,
  },
);
